import { Component, AfterViewInit, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { GenericDialogData } from './generic-dialog-data';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'generic-dialog-component',
  templateUrl: 'generic-dialog.component.html',
  styleUrls: ['./generic-dialog.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
  ],
})
export class GenericDialogComponent implements AfterViewInit {
  data = inject<GenericDialogData>(MAT_DIALOG_DATA);

  
 

  

  ngAfterViewInit() {
    const dialogTitle = document.getElementById('dialogMainContentTitle');
    if (dialogTitle) {
      dialogTitle.focus();
    }
  }
}
